import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";

export const AssistanceChart = ({ data, testId }) => (
  <div className="h-64 w-full" data-testid={testId}>
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ top: 8, right: 8, left: -18, bottom: 0 }} barGap={6}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5eaf0" vertical={false} />
        <XAxis dataKey="label" tick={{ fontSize: 12, fill: "#64748b" }} axisLine={false} tickLine={false} interval={0} />
        <YAxis tick={{ fontSize: 12, fill: "#64748b" }} axisLine={false} tickLine={false} allowDecimals={false} />
        <Tooltip
          cursor={{ fill: "rgba(31,58,95,0.05)" }}
          contentStyle={{ borderRadius: 12, border: "1px solid #e5eaf0", fontSize: 13 }}
          formatter={(v, n) => [`${v} min`, n]}
        />
        <Legend wrapperStyle={{ fontSize: 13 }} />
        <Bar dataKey="prescribed" name="Prescritti" fill="#7aa7c7" radius={[6, 6, 0, 0]} maxBarSize={48} />
        <Bar dataKey="executed" name="Eseguiti" fill="#7fb09a" radius={[6, 6, 0, 0]} maxBarSize={48} />
      </BarChart>
    </ResponsiveContainer>
  </div>
);
